import { ContactDetailsBlockProps } from "/Models/Generated/ContactDetailsBlockProps";
import {
  ArrowLineUpRightIcon,
  BlockTop,
  EnvelopeIcon,
  HashStraightIcon,
  Link,
  MapPinIcon,
  OptimizelyEditProperty,
  PaperPlaneTiltIcon,
  PhoneIcon,
} from "/App.Components";
import "./ContactDetailsBlock.scss";

const contactIcons = {
  MapPin: MapPinIcon,
  Envelope: EnvelopeIcon,
  Phone: PhoneIcon,
  PaperPlaneTilt: PaperPlaneTiltIcon,
  HashStraight: HashStraightIcon,
};

const ContactDetailsBlock = ({
  heading,
  headingPropertyName,
  items,
  itemsPropertyName,
}: ContactDetailsBlockProps) => (
  <div className="contact-details-block">
    {(heading || headingPropertyName) && (
      <BlockTop heading={heading} headingPropertyName={headingPropertyName} />
    )}

    <OptimizelyEditProperty propertyName={itemsPropertyName}>
      {(items?.length ?? 0) > 0 && (
        <ul className="contact-details-block__list">
          {items
            .filter((item) => !!item)
            .map((item, idx) => {
              const hasValue = !!(item.email || item.phone || item.link || item.text);
              if (!hasValue) return null;

              const Icon = item.icon
                ? contactIcons[item.icon as keyof typeof contactIcons]
                : undefined;

              return (
                <li
                  key={idx}
                  className="contact-details-block__row"
                >
                  <div className="contact-details-block__label">
                    {Icon && <Icon size="20" thickness="Thin" />}
                    {item.label && <span>{item.label}</span>}
                  </div>
                  <div className="contact-details-block__value">
                    {item.email && (
                      <Link
                        href={`mailto:${item.email}`}
                        text={item.email}
                        isExternal={false}
                        size="x-small"
                        contained
                        hasUnderline
                      />
                    )}
                    {item.phone && (
                      <span className="contact-details-block__plain-text">
                        {item.phone}
                      </span>
                    )}
                    {item.link && (
                      <Link
                        {...item.link}
                        target={item.link.isExternal ? "_blank" : undefined}
                        size="x-small"
                        contained
                        hasUnderline
                        icon={item.link.isExternal ? ArrowLineUpRightIcon : undefined}
                        iconThickness="Light"
                        iconPlacement="after"
                        iconSize="20"
                        fixedIcon
                      />
                    )}
                    {item.text && (
                      <span className="contact-details-block__plain-text">{item.text}</span>
                    )}
                  </div>
                </li>
              );
            })}
        </ul>
      )}
    </OptimizelyEditProperty>
  </div>
);

export default ContactDetailsBlock;
